import { Button, OptionList, Popover } from '@shopify/polaris';
import { useCallback, useEffect, useState } from 'react';

const DropdownFilter = ({ onFilterChange, defaultValue, options, slug, title }) => {
  const [popoverActive, setPopoverActive] = useState(false);
  const [selected, setSelected] = useState([]);

  const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), []);

  useEffect(() => {
    setSelected(defaultValue ? defaultValue.split(':').map((v) => (Number.isNaN(Number(v)) ? v : Number(v))) : []);
  }, [defaultValue]);

  const handleSelectionChange = useCallback(
    (selected) => {
      setSelected(selected);
      onFilterChange({
        slug,
        value: selected.join(':'),
      });
    },
    [onFilterChange, slug],
  );

  const activator = (
    <Button onClick={togglePopoverActive} disclosure primary={selected.length}>
      {title}
    </Button>
  );

  return (
    <Popover active={popoverActive} activator={activator} onClose={togglePopoverActive}>
      <OptionList title={title} onChange={handleSelectionChange} options={options} selected={selected} allowMultiple />
    </Popover>
  );
};

export default DropdownFilter;
